export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-singapore-d7e8bc693e2054fcdea85d479816d1f9.jpg";